export default {
  /* 内容管理相关接口begin */
  getContentTreeData: {
    method: 'get',
    url: '/v1/scene/DirectoryTree/directories'
  },
  getMaterialListData: {
    method: 'get',
    url: '/v1/scene/articleMaterial/materials'
  },
  deleteMaterials: {
    method: 'delete',
    url: '/v1/scene/articleMaterial/materials'
  },
  updateMaterials: {
    method: 'patch',
    url: '/v1/scene/articleMaterial/materials/{id}'
  },
  uploadMaterials: {
    method: 'post',
    url: '/v1/scene/articleMaterial/materials'
  },
  transferData: {
    method: 'patch',
    url: '/v1/scene/articleDetail/batchOperation'
  },
  addDirectories: {
    method: 'post',
    url: '/v1/scene/DirectoryTree/directories'
  },
  editDirectories: {
    method: 'patch',
    url: '/v1/scene/DirectoryTree/directories/{id}'
  },
  deleteDirectories: {
    method: 'delete',
    url: '/v1/scene/DirectoryTree/directories/{id}'
  },
  getSubArticlesListData: {
    method: 'get',
    url: '/v1/scene/articleDetail/subArticles'
  },
  getArticlesListData: {
    method: 'get',
    url: '/v1/scene/articleDetail/articles'
  },
  deleteSubArticles: {
    method: 'delete',
    url: '/v1/scene/articleDetail/subArticles'
  },
  deleteArticles: {
    method: 'delete',
    url: '/v1/scene/articleDetail/articles'
  },
  /* 内容管理相关接口end */
  getVisitData: {
    method: 'get',
    url: '/v1/bargainConfigure/bargainVisitData/{id}'
  },
  getSpreadData: {
    method: 'get',
    url: '/v1/bargainConfigure/bargainSpread/{id}'
  },
  getBargainInfo: {
    method: 'get',
    url: '/v1/bargainConfigure/bargainContent/{id}'
  },
  deleteBargain: {
    method: 'delete',
    url: '/v1/bargainConfigure/bargainContent/{id}'
  },

  getReserveVisitData: {
    method: 'get',
    url: '/v1/basic/getCampainH5IntegretDataById'
  },
  getRecommendVisitData: {
    method: 'get',
    url: '/v1/basic/getInviteIntegretDataById'
  },
  changeStatusDataStart: {
    method: 'put',
    url: '/v1/bargainConfigure/resume'
  },
  changeStatusDataStop: {
    method: 'put',
    url: '/v1/bargainConfigure/hangUp'
  },
  getRecommendDatail: {
    method: 'get',
    url: '/v1/invitationConfigure/getInviteDetailByIdForE'
  },
  getSignUPCols: {
    method: 'get',
    url: '/v1/signUpConfigure/getAllColumns'
  },
  getReservationDetail: {
    method: 'get',
    url: '/v1/signUpConfigure/getCampainH5ByIdForE'
  },
  saveReservation: {
    method: 'post',
    url: '/v1/signUpConfigure/signUp'
  },
  saveRecommend: {
    method: 'post',
    url: '/v1/invitationConfigure/saveOrUpdateCampaignInvite'
  },
  getColumForUpdate: {
    method: 'get',
    url: '/v1/signUpConfigure/getColumForUpdate'
  }
}
